"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMaskDataForDesignArea = exports.designAreaAppliesMask = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _circle = _interopRequireDefault(require("../../../Resources/Masks/circle.svg"));
var _configuration = require("../../configuration");
var _Selectors = require("../Configurator/Selectors");
var _Selectors2 = require("./Selectors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var maskTypes = {
  circle: 'circle',
  freeForm: 'freeForm'
};
var getMaskIfComplete = function getMaskIfComplete(obj) {
  return maskTypes[(0, _get["default"])(obj, 'mask.maskType')] && _objectSpread(_objectSpread({}, obj.mask.maskData), {}, {
    type: obj.mask.maskType,
    source: obj
  });
};
var designAreaAppliesMask = exports.designAreaAppliesMask = function designAreaAppliesMask(state, designArea) {
  if (!designArea) {
    designArea = (0, _Selectors2.getSelectedDesignArea)(state);
  }
  var designProductionMethod = (0, _Selectors2.getSelectedDesignProductionMethodForDesignArea)(state, designArea);
  return !!(getMaskIfComplete(designProductionMethod) || getMaskIfComplete(designArea));
};
var getMaskSrc = function getMaskSrc(_ref) {
  var itemIdentifier = _ref.itemIdentifier,
    designAreaIdentifier = _ref.designAreaIdentifier,
    designProductionMethodIdentifier = _ref.designProductionMethodIdentifier,
    type = _ref.type;
  switch (type) {
    case maskTypes.circle:
      {
        return _circle["default"];
      }
    case maskTypes.freeForm:
      {
        var fileName = designProductionMethodIdentifier ? "".concat(designAreaIdentifier, "_").concat(designProductionMethodIdentifier) : designAreaIdentifier;
        return "".concat((0, _configuration.getConf)('network.host'), "/designer/masks/").concat(itemIdentifier, "/").concat(fileName, ".svg");
      }
    default:
      {
        return false;
      }
  }
};
var getMaskDataForDesignArea = exports.getMaskDataForDesignArea = function getMaskDataForDesignArea(state) {
  var designArea = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!designArea) {
    designArea = (0, _Selectors2.getSelectedDesignArea)(state);
  }
  var designProductionMethod = (0, _Selectors2.getSelectedDesignProductionMethodForDesignArea)(state, designArea);
  var item = (0, _Selectors.getItem)((0, _Selectors.getConfigurator)(state));
  var maskData = getMaskIfComplete(designProductionMethod) || getMaskIfComplete(designArea);
  if (maskData) {
    var src = getMaskSrc({
      itemIdentifier: item.identifier,
      designAreaIdentifier: designArea.identifier,
      designProductionMethodIdentifier: maskData.source === designProductionMethod ? designProductionMethod.identifier : false,
      type: maskData.type
    });
    return _objectSpread(_objectSpread({}, maskData), {}, {
      src: src,
      outlineColor: (0, _Selectors.getClientHighlightColor)(state)
    });
  }
  return false;
};